import { render, staticRenderFns } from "./IconAddPrimary.vue?vue&type=template&id=cbe0f12c&"
var script = {}
import style0 from "./IconAddPrimary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbe0f12c')) {
      api.createRecord('cbe0f12c', component.options)
    } else {
      api.reload('cbe0f12c', component.options)
    }
    module.hot.accept("./IconAddPrimary.vue?vue&type=template&id=cbe0f12c&", function () {
      api.rerender('cbe0f12c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconAddPrimary.vue"
export default component.exports